module.exports = __webpack_public_path__ + "img/max.b21fcbbc.png";